import type { ErrorMap } from '@/app/error-registry';

/** Checklist-level operations: create (POST), rename/reorder (PATCH), delete (DELETE). */
export const CHECKLISTS_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectTask.NotFound': 'checklists:apiErrors.createNotFound',
    'Checklist.NameEmpty': 'checklists:apiErrors.nameEmpty',
    'ChecklistName.Required': 'checklists:apiErrors.nameRequired',
    'ChecklistName.TooLong': 'checklists:apiErrors.nameTooLong',
    forbidden: 'checklists:apiErrors.createForbidden',
    validation: 'checklists:apiErrors.createValidation',
    default: 'checklists:apiErrors.createDefault',
  },
  PATCH: {
    'Checklist.NotFound': 'checklists:apiErrors.updateNotFound',
    'Checklist.NameEmpty': 'checklists:apiErrors.nameEmpty',
    'ChecklistName.Required': 'checklists:apiErrors.nameRequired',
    'ChecklistName.TooLong': 'checklists:apiErrors.nameTooLong',
    forbidden: 'checklists:apiErrors.updateForbidden',
    validation: 'checklists:apiErrors.updateValidation',
    default: 'checklists:apiErrors.updateDefault',
  },
  DELETE: {
    'Checklist.NotFound': 'checklists:apiErrors.deleteNotFound',
    forbidden: 'checklists:apiErrors.deleteForbidden',
    default: 'checklists:apiErrors.deleteDefault',
  },
};

/** Item-level operations: add/move/convert (POST), edit (PATCH), delete (DELETE). */
export const CHECKLIST_ITEMS_ERROR_MAP: ErrorMap = {
  POST: {
    'Checklist.NotFound': 'checklists:apiErrors.itemDefault',
    'Checklist.ItemNotFound': 'checklists:apiErrors.itemDefault',
    'Checklist.TargetChecklistNotFound': 'checklists:apiErrors.targetChecklistNotFound',
    'Checklist.CannotMoveToSameChecklist': 'checklists:apiErrors.cannotMoveToSameChecklist',
    'ChecklistItemTitle.Required': 'checklists:apiErrors.itemTitleRequired',
    'ChecklistItemTitle.TooLong': 'checklists:apiErrors.itemTitleTooLong',
    'ProjectTask.MaxDepthExceeded': 'checklists:apiErrors.convertToSubtaskDepth',
    forbidden: 'checklists:apiErrors.itemForbidden',
    validation: 'checklists:apiErrors.itemValidation',
    default: 'checklists:apiErrors.itemDefault',
  },
  PATCH: {
    'Checklist.ItemNotFound': 'checklists:apiErrors.itemUpdateDefault',
    'Checklist.ItemNotInChecklist': 'checklists:apiErrors.itemNotInChecklist',
    'ChecklistItemTitle.Required': 'checklists:apiErrors.itemTitleRequired',
    'ChecklistItemTitle.TooLong': 'checklists:apiErrors.itemTitleTooLong',
    forbidden: 'checklists:apiErrors.itemForbidden',
    validation: 'checklists:apiErrors.itemValidation',
    default: 'checklists:apiErrors.itemUpdateDefault',
  },
  DELETE: {
    'Checklist.ItemNotFound': 'checklists:apiErrors.itemDeleteDefault',
    forbidden: 'checklists:apiErrors.itemForbidden',
    default: 'checklists:apiErrors.itemDeleteDefault',
  },
};
